<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="bonuses"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { fetchBonusesList } from '@/apollo/bonuses'

export default {
	apollo: {
		bonuses: fetchBonusesList()
	},
	data() {
		return {
			section: 'bonos',
			itemsTable: 'bonuses',
			itemsTitles: ['Id', 'title', 'Pais', 'Empresa', 'dateFrom', 'dateTo']
		}
	},
	components: { ListTable }
}
</script>
